//react
import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mobile, PC } from "../../media/MediaQuery";

//css
import styled from "styled-components";

// responsive
import { M, T } from "../../utils/MT";

// component
export default function MyPageMenu({ preOrder }) {
    //페이지 이동
    const navigate = useNavigate();

    // 메뉴 클릭시 색 변경.
    const { pathname } = useLocation();

    // 메뉴 리스트
    const MenuListData = [
        {
            title: "나의 쇼핑정보",
            subMenu: [
                {
                    subtitle: "주문/배송조회",
                    path: [`/mypage/myorder`, `/mypage/order_detail/0`],
                },
                {
                    subtitle: "취소/교환/반품 내역",
                    path: [`/mypage/mycancel`, `/mypage/cancel_detail`],
                },
            ],
        },
        {
            title: "정보관리",
            subMenu: [
                {
                    subtitle: "개인정보수정",
                    path: [`/mypage/myedit`, `/mypage/myedit/detail`, `/mypage/memberout`, `/mypage/memberout/detail`],
                },
                {
                    subtitle: "회원등급",
                    path: [`/mypage/mygrade`],
                },
                {
                    pre: true, // 프리오더일때 안보이게되는 곳
                    subtitle: "적립금",
                    path: [`/mypage/mypoint`],
                },
                {
                    pre: true, // 프리오더일때 안보이게되는 곳
                    subtitle: "쿠폰",
                    path: [`/mypage/mycoupon`],
                },
            ],
        },
        {
            title: "고객센터",
            subMenu: [
                {
                    subtitle: "1:1문의",
                    path: [`/mypage/myinquiry`, `/mypage/myinquiry/new`],
                },
            ],
        },
    ];

    // 마이페이지 사이드 메뉴
    return (
        <>
            <PC>
                <MyPageTitle>
                    MY <br /> PAGE
                </MyPageTitle>
            </PC>

            <MyMenuListBox>
                {MenuListData.map((item, index) => {
                    return (
                        <MyMenuList key={"menuList" + index}>
                            <MyMenuTitle>{item.title}</MyMenuTitle>
                            {item.subMenu.map((list, i) => {
                                /* 프리오더일때는 적립금과 쿠폰 메뉴가 없습니다! */
                                if (preOrder === true && list.pre === true) return;
                                return (
                                    <MyMenu
                                        key={"subMenu" + i}
                                        onClick={() => {
                                            navigate(`${list.path[0]}`);
                                        }}
                                        selected={list.path.includes(pathname)}
                                    >
                                        {list.subtitle}
                                    </MyMenu>
                                );
                            })}
                        </MyMenuList>
                    );
                })}
            </MyMenuListBox>
        </>
    );
}

const MyPageTitle = styled.h2`
    font-size: calc(100vw * (40 / 1920));
    font-family: "Pop-L";
    line-height: 1;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (40 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(40)};
    }
`;
const MyMenuListBox = styled.div`
    /* margin-top: calc(100vw * (18 / 1920)); */
    margin-top: calc(100vw * (58 / 1920));

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (58 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(40)};
    }
`;
const MyMenuList = styled.ul`
    &:not(:first-child) {
        margin-top: calc(100vw * (40 / 1920));
    }

    @media screen and (max-width: 1300px) {
        &:not(:first-child) {
            margin-top: calc(100vw * (40 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        &:not(:first-child) {
            padding-top: ${M(25)};
            margin-top: ${M(25)};

            border-top: 1px solid #eee;
        }
    }
`;

const MyMenuTitle = styled.li`
    font-family: "Noto-Black";

    margin-bottom: calc(100vw * (20 / 1920));
    font-size: calc(100vw * (15 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (20 / 1300));
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(20)};
        font-size: ${M(14)};
    }
`;
const MyMenu = styled.li`
    font-family: "Noto-R";
    margin-top: calc(100vw * (20 / 1920));
    font-size: calc(100vw * (15 / 1920));

    cursor: pointer;

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (20 / 1300));
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(20)};
        font-size: ${M(14)};
    }

    ${({ selected }) => {
        return selected ? `color: var(--main-color); font-weight: bold` : "color: #222;";
    }}
`;
